<div class="preview-wrapper" #wrapper>
    <img #image [src]="url">

    <section>
        <div class="description">{{description}}</div>
        <div class="size-wrapper">
            <span class="size">{{humanSize}}</span>
            <span class="suffix">{{humanSizeSuffix}}</span>
        </div>
    </section>
</div>